import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import * as styles from './styles.css';

/* istanbul ignore next */
export const Skeleton: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Spinner size={32} color="icon-main-default" />
    </div>
  );
};
